import { Role } from '@gm-commercial/profile-model';
import { EMER_FLAG, GEOFENCES_FLAG } from '~/common/models/featureFlags.model';
import { NOTIFICATION_ROUTE_AUTH } from '~/common/models/notification.model';
import {
  SETTINGS_NOTIFICATIONS_ACCOUNT_DETAIL,
  SETTINGS_NOTIFICATIONS_SAFETY_AND_SECURITY_DETAIL,
  SETTINGS_NOTIFICATIONS_VEHICLES_DETAIL,
  SETTINGS_NOTIFICATIONS_VEHICLES_DIAGNOSTICS_DETAIL,
  SETTINGS_NOTIFICATIONS_VEHICLES_DIAGNOSTICS_NEW,
  SETTINGS_NOTIFICATIONS_VEHICLES_GEOFENCE_DETAIL,
} from '~/common/models/pages/settingsPages.model';
import { RouteName } from '~/common/models/route.model';
import { lazyWithReload } from '~/common/utils/lazyWithReload';

const AccountNotificationDetailView = lazyWithReload(
  () => import('~/routes/settings/detail/AccountNotificationDetailView')
);
const SafetySecurityNotificationDetailView = lazyWithReload(
  () => import('~/routes/settings/detail/SafetySecurityNotificationDetailView')
);
const VehicleNotificationDetailView = lazyWithReload(
  () => import('~/routes/settings/detail/VehicleNotificationDetailView')
);
const DiagnosticsNotificationView = lazyWithReload(
  () => import('~/routes/settings/detail/DiagnosticsNotificationView')
);
const GeofenceNotificationDetailView = lazyWithReload(
  () => import('~/routes/settings/detail/GeofenceNotificationDetailView')
);

/**
 * Full-page detail routes for single notifications. They need the EMER flag;
 * without it the notification settings keep the list pages and edit dialog.
 * The vehicles route stays open because it also served the old Vehicles list
 * (see VehicleNotificationDetailView).
 */
export const NOTIFICATION_SETTINGS_ROUTES = {
  [RouteName.CS_PLATFORM_ACCOUNT_NOTIFICATION_DETAIL]: {
    name: RouteName.CS_PLATFORM_ACCOUNT_NOTIFICATION_DETAIL,
    path: SETTINGS_NOTIFICATIONS_ACCOUNT_DETAIL,
    ...NOTIFICATION_ROUTE_AUTH,
    authorizedPerms: [],
    element: AccountNotificationDetailView,
    requiredFeatureFlags: [EMER_FLAG],
  },
  [RouteName.CS_PLATFORM_SAFETY_AND_SECURITY_NOTIFICATION_DETAIL]: {
    name: RouteName.CS_PLATFORM_SAFETY_AND_SECURITY_NOTIFICATION_DETAIL,
    path: SETTINGS_NOTIFICATIONS_SAFETY_AND_SECURITY_DETAIL,
    ...NOTIFICATION_ROUTE_AUTH,
    authorizedPerms: [],
    excludedRoles: [Role.OPERATOR],
    element: SafetySecurityNotificationDetailView,
    requiredFeatureFlags: [EMER_FLAG],
  },
  [RouteName.CS_PLATFORM_VEHICLE_NOTIFICATION_DETAIL]: {
    name: RouteName.CS_PLATFORM_VEHICLE_NOTIFICATION_DETAIL,
    path: SETTINGS_NOTIFICATIONS_VEHICLES_DETAIL,
    ...NOTIFICATION_ROUTE_AUTH,
    authorizedPerms: [],
    element: VehicleNotificationDetailView,
  },
  [RouteName.CS_PLATFORM_DIAGNOSTICS_NOTIFICATION_NEW]: {
    name: RouteName.CS_PLATFORM_DIAGNOSTICS_NOTIFICATION_NEW,
    path: SETTINGS_NOTIFICATIONS_VEHICLES_DIAGNOSTICS_NEW,
    ...NOTIFICATION_ROUTE_AUTH,
    authorizedPerms: [],
    element: DiagnosticsNotificationView,
    requiredFeatureFlags: [EMER_FLAG],
  },
  [RouteName.CS_PLATFORM_DIAGNOSTICS_NOTIFICATION_DETAIL]: {
    name: RouteName.CS_PLATFORM_DIAGNOSTICS_NOTIFICATION_DETAIL,
    path: SETTINGS_NOTIFICATIONS_VEHICLES_DIAGNOSTICS_DETAIL,
    ...NOTIFICATION_ROUTE_AUTH,
    authorizedPerms: [],
    element: DiagnosticsNotificationView,
    requiredFeatureFlags: [EMER_FLAG],
  },
  [RouteName.CS_PLATFORM_GEOFENCE_NOTIFICATION_DETAIL]: {
    name: RouteName.CS_PLATFORM_GEOFENCE_NOTIFICATION_DETAIL,
    path: SETTINGS_NOTIFICATIONS_VEHICLES_GEOFENCE_DETAIL,
    ...NOTIFICATION_ROUTE_AUTH,
    authorizedPerms: [],
    element: GeofenceNotificationDetailView,
    requiredFeatureFlags: [GEOFENCES_FLAG, EMER_FLAG],
  },
};
